module.exports = __webpack_public_path__ + "img/Swiper.e8d18ea0.png";